(()=> {
  function setXSellFn(){
    console.log('setXSellFn')
    var cart_add_btns = document.querySelectorAll('.cart_add_btn_x_sell');
    if( cart_add_btns.length > 0 ){
      cart_add_btns.forEach(cart_add_btn => {
          console.log("cart_add_btn_x_sell: ",cart_add_btn);
          var variant_id = cart_add_btn.getAttribute('data-variant-id');
          //console.log("cart_add_btn_x_sell: ",cart_add_btn, " variant_id: ",variant_id);
          cart_add_btn.dataset.listenerAttached = 'true';
          cart_add_btn.addEventListener("click", () => {
              //console.log("clicked element");
              addXSellProductToCart(variant_id);
          });
      });
    }
  }
  
  function addXSellProductToCart(variant){
    //console.log("addFreeGiftsToCart",variant);
    document.querySelector('#sidebar-cart .Cart').classList.add('loading')
    let formData = {
      'items': [{ 'id': variant, 'quantity': 1 }],
      'sections': ['cart-drawer'],
      'sections_url': window.location.pathname
    };
    fetch(window.routes.cartUrl + '/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      response.json().then(function (content) {
        const updatedCart = new DOMParser().parseFromString(content.sections['cart-drawer'], 'text/html').querySelector('.Cart');            
        document.querySelector('#sidebar-cart .Cart').innerHTML = updatedCart.innerHTML;            
        document.querySelector('#sidebar-cart .Cart').classList.remove('loading'); 
      });
      document.dispatchEvent(new CustomEvent('theme:loading:start'));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
  document.addEventListener('rerender_cart_event', (ev)=> { setXSellFn() });
  document.addEventListener("DOMContentLoaded", (ev)=> { setXSellFn() });
})();